import React from "react";
import "../../App.css";
import AboutMeSection from "../AboutMeSection";

export default function AboutMe() {
  return (
    <>
      {/* <h1
        style={{ backgroundImage: 'url("/assets/images/acro1.jpeg")' }}
        className="about-me"
      >
        About Me
      </h1> */}
      <AboutMeSection />
    </>
  );
}
